h<template>
	<div>
		<layout-9
			:id=pageid1
			:idTime=pageid2
			:idMaterial=pageid3
			:idPonumber=pageid4
			:idComplete=pageid5
			:idAddrs=pageid6
			:idHourCalc=pageid7
			:idMaterialRate=pageid8
			:idDocuments=pageid9
			:idAdditionaljoborders=pageid10
			:term=term
			style="width:100%; height:calc(100vh - 50px);"
		></layout-9>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			pageid1:PAGES.CREATE_INVOICE_PAGE,
			pageid2:PAGES.CREATE_INVOICE_PAGE_TIME,
			pageid3:PAGES.CREATE_INVOICE_PAGE_MATERIAL,
			pageid4:PAGES.CREATE_INVOICE_PAGE_PONUMBER,
			pageid5:PAGES.CREATE_INVOICE_PAGE_COMPLETE,
			pageid6:PAGES.CREATE_INVOICE_PAGE_ADDRESS,
			pageid7:PAGES.CREATE_INVOICE_PAGE_HOURCALC,
			pageid8:PAGES.CREATE_INVOICE_PAGE_MATERIALRATE,
			pageid9:PAGES.CREATE_INVOICE_PAGE_DOCUMENTS,
			pageid10:PAGES.CREATE_INVOICE_PAGE_ADDITIONALJOBORDERS,
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/add/Add_Invoice_Prep.vue